<template>
  <div class="col-auto">
    <span v-if="!detailedSelected">
      <base-button link type="primary" @click="previousYear()">
        <i class="tim-icons icon-minimal-left"></i>
      </base-button>
      <base-button link type="primary">{{ selectedYear }}</base-button>
      <base-button link type="primary" @click="nextYear()">
        <i class="tim-icons icon-minimal-right"></i>
      </base-button>
            <el-select placeholder="Month" class="select-primary" size="large" v-model="selectedMonth"
                       @change="calendarPeriodChanged">
              <el-option
                v-for="option in monthSelect"
                class="select-primary"
                :value="option.value"
                :label="option.label"
                :key="option.label"
              ></el-option>
            </el-select>
    </span>
    <span v-else>
      <base-input class="d-inline-block">
        <el-date-picker
          size="large"
          @change="dateRangeChanged"
          v-model="dateRange"
          type="daterange"
          :clearable="false"
          :start-placeholder="$t('detailedReportPeriod.fromDatePlaceholder')"
          :end-placeholder="$t('detailedReportPeriod.toDatePlaceholder')">
                  <template slot="range-separator">
                  {{ $t('detailedReportPeriod.toDate') }}
                  </template>
                </el-date-picker>
      </base-input>
    </span>
    <base-input class="ml-3 d-inline-block">

      <base-checkbox v-model="detailedSelected" @input="detailedPeriodChanged()">
        {{ $t('detailedReportPeriod.detailedSelectionLabel') }}
      </base-checkbox>
    </base-input>
  </div>
</template>

<script>
import {DatePicker, Option, Select} from 'element-ui';
import {BaseCheckbox, BaseSwitch} from 'src/components';
import {mapActions, mapState} from "vuex";

export default {
  name: "DetailedReportPeriod",
  props: {
    initialPeriod: {
      type: Function,
      required: false,
      description: 'Callback function to inform initial period.'
    },
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [BaseSwitch.name]: BaseSwitch,
    [BaseCheckbox.name]: BaseCheckbox,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      detailedSelected: false,
      selectedMonth: (new Date()).getMonth() + 1,
      selectedYear: (new Date()).getFullYear(),
      dateRange: [
        new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1),
        new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 1),
      ]
    };
  },
  computed: {
    ...mapState({
      selectedReportPeriod: state => state.profile.selectedReportPeriod,
    }),
    monthSelect() {
      return [
        {value: 1, label: this.$t('months.january')},
        {value: 2, label: this.$t('months.february')},
        {value: 3, label: this.$t('months.march')},
        {value: 4, label: this.$t('months.april')},
        {value: 5, label: this.$t('months.may')},
        {value: 6, label: this.$t('months.june')},
        {value: 7, label: this.$t('months.july')},
        {value: 8, label: this.$t('months.august')},
        {value: 9, label: this.$t('months.september')},
        {value: 10, label: this.$t('months.october')},
        {value: 11, label: this.$t('months.november')},
        {value: 12, label: this.$t('months.december')},
      ]
    },
  },
  methods: {
    ...mapActions(['SetProfileSelectedReportPeriod']),
    nextYear() {
      this.selectedYear += 1
      this.calendarPeriodChanged()
    },
    previousYear() {
      this.selectedYear -= 1
      this.calendarPeriodChanged()
    },
    detailedPeriodChanged() {
      let apiQuery = null
      if (this.detailedSelected) {
        this.dateRange = [
          new Date(this.selectedYear, this.selectedMonth - 1, 1),
          new Date(this.selectedYear, this.selectedMonth, 1),
        ]

        apiQuery=this.prepareRangeApiQuery()
        this.changeUrlWithDateRange()
      } else {

        this.selectedYear = this.dateRange[0].getFullYear()
        this.selectedMonth = this.dateRange[0].getMonth() + 1

        apiQuery = {
          year: this.selectedYear,
          month: this.selectedMonth
        }
        this.changeUrlWithCalendarPeriod()
      }
      this.SetProfileSelectedReportPeriod(apiQuery)
    },
    prepareRangeApiQuery() {
      return {
        from: new Date(this.dateRange[0].getTime() - (this.dateRange[0].getTimezoneOffset() * 60000))
          .toISOString()
          .split("T")[0],
        to: new Date(this.dateRange[1].getTime() - (this.dateRange[1].getTimezoneOffset() * 60000))
          .toISOString()
          .split("T")[0]
      }
    },
    dateRangeChanged() {
      let apiQuery = this.prepareRangeApiQuery()
      this.changeUrlWithDateRange();
      this.SetProfileSelectedReportPeriod(apiQuery)
    },
    changeUrlWithDateRange() {
      let apiQuery = this.prepareRangeApiQuery();
      const removeKey = (key, {[key]: _, ...rest}) => rest;
      let tmp = removeKey("year", this.$route.query)
      tmp = removeKey("month", tmp)
      this.$router.replace({
        query: Object.assign({}, tmp, {
          from: apiQuery.from,
          to: apiQuery.to
        })
      });
    },
    changeUrlWithCalendarPeriod() {
      const removeKey = (key, {[key]: _, ...rest}) => rest;
      let tmp = removeKey("from", this.$route.query)
      tmp = removeKey("to", tmp)
      this.$router.replace({
        query: Object.assign({}, tmp, {
          year: this.selectedYear,
          month: this.selectedMonth
        })
      });
    },
    calendarPeriodChanged() {
      let apiQuery = {
        year: this.selectedYear,
        month: this.selectedMonth
      }
      this.changeUrlWithCalendarPeriod()
      this.SetProfileSelectedReportPeriod(apiQuery)
    },
    parseCalendarPeriod(something) {
      let period = null;
      if (something.year && something.year != '') {
        let year = parseInt(something.year, 10)
        if (!isNaN(year)) {
          if (something.month && something.month != '') {
            let month = parseInt(something.month, 10)
            if (!isNaN(month)) {
              this.selectedYear = year;
              this.selectedMonth = month;
              period = {
                year: this.selectedYear,
                month: this.selectedMonth
              }
            }
          }
        }
      }

      return period
    },
    parseDateRangePeriod(something) {
      let period = null;
      if (something.from && something.from != '') {
        let dateFrom = Date.parse(something.from)
        if (!isNaN(dateFrom)) {
          if (something.to && something.to != '') {
            let dateTo = Date.parse(something.to)
            if (!isNaN(dateTo)) {
              if (dateFrom < dateTo) {
                this.dateRange[0] = new Date(dateFrom);
                this.dateRange[1] = new Date(dateTo);
                this.detailedSelected = true

                period = this.prepareRangeApiQuery()
              }
            }
          }
        }
      }

      return period
    },
  },
  mounted() {
    let period = null

    period = this.parseCalendarPeriod({year: this.$route.query.year, month: this.$route.query.month})
    if (period != null) {
      // Period from PATH
      this.SetProfileSelectedReportPeriod(period)
      if (this.initialPeriod) {
        this.initialPeriod(period)
      }
      return
    }

    period = this.parseDateRangePeriod({from: this.$route.query.from, to: this.$route.query.to})
    if (period != null) {
      // Period from PATH
      this.SetProfileSelectedReportPeriod(period)
      if (this.initialPeriod) {
        this.initialPeriod(period)
      }
      return
    }

    if (this.selectedReportPeriod) {
      period = this.parseCalendarPeriod(this.selectedReportPeriod)
      if (period != null) {
        // Period from PATH
        this.SetProfileSelectedReportPeriod(period)
        this.changeUrlWithCalendarPeriod()
        if (this.initialPeriod) {
          this.initialPeriod(period)
        }
        return
      }

      period = this.parseDateRangePeriod(this.selectedReportPeriod)
      if (period != null) {
        // Period from PATH
        this.SetProfileSelectedReportPeriod(period)
        this.changeUrlWithDateRange()
        if (this.initialPeriod) {
          this.initialPeriod(period)
        }
        return
      }
    }

    period = {
      year: this.selectedYear,
      month: this.selectedMonth
    }
    this.changeUrlWithCalendarPeriod()
    this.SetProfileSelectedReportPeriod(period)
    if (this.initialPeriod) {
      this.initialPeriod(period)
    }
  },
}
</script>

<style scoped>

</style>
